<!-- <div class="back-overlay">
</div> -->
<div class="offer-bottom-popup">
  <div>
    <ion-card>
      <ion-card-header [ngStyle]="{'border-color':featureItem?.bgcolor}" style="border-top: 5px solid;">
        <ion-card-subtitle>
          <ion-row>
            <ion-col class="ion-text-center ion-align-self-center">
              <h2 class="unveri-font">{{featureItem.title}}</h2>
            </ion-col>
          </ion-row>
          <ion-icon name="close-outline" (click)="close()" [ngStyle]="{'color': featureItem?.bgcolor}" style="right: 0;position: absolute;font-size: 2rem;top:0;z-index: 999999;"></ion-icon>
       </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content [ngStyle]="{'border-color': featureItem?.bgcolor}" style="border-bottom: 5px solid;">
        <!-- <span class="ion-text-center">
          
          <ion-icon name="close-outline" (click)="close()" class="close"></ion-icon>
        </span> -->

        <div class="plan-container">
          <!-- <ion-row>
            <ion-col class="ion-text-center ion-align-self-center">
              <h2 class="unveri-font">{{featureItem.title}}</h2>
            </ion-col>
          </ion-row> -->
          <ion-row>
            <ion-col class="ion-text-center ion-align-self-center">
              <img [src]="featureItem.popImage" style="height: auto;
              width: 45%;"/>
            </ion-col>
          </ion-row>
          <!-- <ion-row>
            <ion-col class="ion-text-left ion-align-self-center">
              <ion-row>
                <ion-col>
                  <span class="sub-foodItem-header">{{featureItem.title}}</span>
                </ion-col>
              </ion-row>
              <ion-row style="padding-top: 5px;">
                <ion-col>
                  <span class="sub-foodItem-sub-header sub-foodItem-sub-header-custom">{{featureItem.subtitle}}</span>
                </ion-col>
              </ion-row>
            <ion-row>
              <ion-col>
                <span class="sub-foodItem-sub-header sub-foodItem-sub-header-custom">{{plan.desc}}</span>
              </ion-col>
            </ion-row>
            </ion-col>
          </ion-row> -->
          <ion-row>
            <ion-col size="2.5" class="ion-padding" style="padding-right:0;">
              <img src="./assets/img/manjri_anime.png"/>
            </ion-col>
            <ion-col  class="ion-padding">
              <div class="box2 sb11">
                <span class="unveri-font">{{featureItem.popupTitle}}</span>
                <br />
                <span class="info-text" [innerHTML]="featureItem.desc"></span>
              </div>
              <!-- <img src="./assets/img/manjri_anime.png"/> -->
            </ion-col>
          </ion-row>
        </div>
      </ion-card-content>

      <!-- <span><span class="border-section-btm"
          [ngStyle]="{'background-color': planType =='weightLoss' ? '#01a3a4' :  planType =='immunity_booster' ? '#FD9F33' : planType =='detox' ? '#4CB271' : '#0B94C1'}"></span></span> -->
    </ion-card>
  </div>
</div>